@let portfolioIdValue = portfolioId();
@if (portfolioIdValue) {
  <cfp-portfolio-report
    [portfolioId]="portfolioIdValue"
    [logo]="logo"
    [organizationName]="organizationName()"
    [organizationId]="organizationId()"
    [reportTitle]="'portfolio-report.title' | translate"
    [customLogo]="customLogo()"
  >
    <div class="print-page-break-inside-avoid">
      <div class="row">
        <div class="col">
          <cfp-portfolio-summary [portfolioId]="portfolioIdValue" />
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6">
          <cfp-portfolio-business-case-card [portfolioId]="portfolioIdValue" />
        </div>
        <div class="col-6">
          <div class="card h-100 card-map">
            <div class="card-body p-0">
              <cfp-portfolio-locations-map
                class="d-flex w-100 h-100 flex-column"
                [moduleRoute]="'/energy'"
                [portfolioId]="portfolioId()"
                [showHeader]="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 pt-3">
        <div class="col-12 col-lg-6 col-print-6">
          <cfp-portfolio-top-measures-card [portfolioId]="portfolioIdValue" />
        </div>
        <div class="col-12 col-lg-6 col-print-6 mt-5 mt-lg-0 mt-print-0">
          @if (portfolioId()) {
            <cfp-portfolio-energy-labels-distribution-card
              [portfolioId]="portfolioIdValue"
              [fullHeight]="true"
              [labelGroup]="labelGroup()"
            />
          }
        </div>
      </div>
      <div class="row my-4">
        <div class="col-12">
          <div class="card h-100">
            <div class="card-body">
              @if (labelDistribution(); as distribution) {
                @if (labelGroup(); as group) {
                  <cfp-portfolio-energy-label-ratings [labelGroup]="group" [labelDistribution]="distribution" />
                }
              }
            </div>
          </div>
        </div>
      </div>
      @if (!hasRoadmapLicence()) {
        <div class="row">
          <div class="col roadmap-disclaimer">
            <div [innerHTML]="'portfolio-report.disclaimer' | translate"></div>
          </div>
        </div>
      }
      @if (hasRoadmapLicence()) {
        <div class="row">
          <div class="col">
            <div [innerHTML]="'portfolio-report.teaserText' | translate"></div>
          </div>
        </div>
      }
    </div>
    @if (hasRoadmapLicence()) {
      <div>
        <div class="print-page-break-inside-avoid">
          @if (!hasRoadmap()) {
            <div class="row mt-4">
              <div class="col-12">
                <div class="alert alert-warning">
                  <div class="row">
                    <div class="col-auto pe-0">
                      <span class="icon-square"><i class="far fa-warning" aria-hidden="true"></i></span>
                    </div>
                    <div class="col">
                      <div class="d-flex flex-column">
                        <h4 class="mb-0">{{ 'portfolio-report.title.no-roadmap' | translate }}</h4>
                        <p class="mb-0">{{ 'portfolio-report.text.no-roadmap' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="row" [ngClass]="{ 'portfolio-blur': !hasRoadmap() }">
            <div class="col-6 col-print-6 mt-5 h-100">
              <cfp-roadmap-chart
                class="printable-roadmap-chart"
                [details]="details()"
                [responsive]="false"
                [propertyNames]="['investment', 'costReduction']"
                [title]="'investmentAndCostReduction'"
                [currencyCode]="details()?.currencyCode"
              />
            </div>
            <div class="col-6 col-print-6 mt-5 h-100">
              <cfp-roadmap-chart
                class="printable-roadmap-chart"
                [details]="details()"
                [propertyNames]="['co2Consumption']"
              />
            </div>
          </div>
          <div class="row" [ngClass]="{ 'portfolio-blur': !hasRoadmap() }">
            <div class="col-6 col-print-6 mt-5 h-100">
              <cfp-roadmap-chart-labels class="printable-roadmap-chart" [details]="details()" [totals]="totals()" />
            </div>
            <div class="col-6 col-print-6 mt-5 h-100">
              <cfp-roadmap-chart
                class="printable-roadmap-chart"
                [details]="details()"
                [propertyNames]="['co2ConsumptionReduction']"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-5">
              <div>
                <p class="report-disclaimer-link" [innerHTML]="'portfolio-report.disclaimer-link' | translate"></p>
              </div>
              <div class="portfolio-report-disclaimer" [innerHTML]="'portfolio-report.disclaimer' | translate"></div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showExplanationPage) {
      <div class="print-page-break-before-always d-none d-print-block">
        <div class="report-explanation-page">
          <h2 class="mb-4">Toelichtingsveld</h2>
          <div class="report-explanation-field"></div>
        </div>
      </div>
    }
  </cfp-portfolio-report>
}
